export default __webpack_public_path__ + "static/about-us-464dcd71ecb8b1f4ccb10d91f5427e55.png";